const recipes = [
  {
    id: 1,
    slug: "smoky-chickpea-sheet-pan",
    title: "Smoky Chickpea & Tomato Sheet Pan",
    excerpt:
      "Crisp chickpeas, collapsing tomatoes, and lemony yogurt built around oak-smoked paprika.",
    image: "/images/generated/recipe-smoky-chickpea.png",
    prepTime: 12,
    cookTime: 28,
    totalTime: 40,
    servings: 4,
    difficulty: "Easy",
    cuisine: "Mediterranean-inspired",
    tags: ["vegetarian", "weeknight", "sheet-pan"],
    ingredients: [
      { amount: "2 cans", item: "chickpeas, drained and dried" },
      { amount: "2 pints", item: "cherry tomatoes" },
      { amount: "2 tbsp", item: "extra-virgin olive oil" },
      { amount: "2 tsp", item: "Ember & Oak Smoked Paprika", productSlug: "smoked-paprika" },
      { amount: "1 tsp", item: "Silk Road Cumin Seed, toasted and crushed", productSlug: "wild-cumin-seed" },
      { amount: "1 tsp", item: "Snowflake Sea Salt", productSlug: "flaky-sea-salt" },
      { amount: "1 cup", item: "plain yogurt" },
      { amount: "1", item: "lemon" },
    ],
    steps: [
      "Heat the oven to 425°F. Toss chickpeas and tomatoes with olive oil, paprika, cumin, and half the salt.",
      "Roast on a wide sheet pan for 25–28 minutes, stirring once, until the chickpeas are crisp and the tomatoes have burst.",
      "Season the yogurt with lemon zest, a squeeze of juice, and the remaining salt.",
      "Spoon the yogurt onto a platter, pile the hot chickpeas and tomatoes over it, and finish with olive oil.",
    ],
    productSlugs: ["smoked-paprika", "wild-cumin-seed", "flaky-sea-salt"],
  },
  {
    id: 2,
    slug: "zaatar-lemon-skillet-flatbreads",
    title: "Za’atar-Lemon Skillet Flatbreads",
    excerpt:
      "Quick yogurt flatbreads brushed with olive oil and a bright, sesame-rich za’atar.",
    image: "/images/generated/recipe-zaatar-flatbreads.png",
    prepTime: 20,
    cookTime: 15,
    totalTime: 35,
    servings: 6,
    difficulty: "Easy",
    cuisine: "Levantine-inspired",
    tags: ["bread", "vegetarian", "sharing"],
    ingredients: [
      { amount: "2 cups", item: "all-purpose flour" },
      { amount: "2 tsp", item: "baking powder" },
      { amount: "3/4 tsp", item: "Rose Quartz Pink Salt", productSlug: "pink-salt" },
      { amount: "1 cup", item: "plain Greek yogurt" },
      { amount: "3 tbsp", item: "extra-virgin olive oil" },
      { amount: "3 tbsp", item: "Cedar Grove Za’atar", productSlug: "zaatar" },
      { amount: "1/2", item: "lemon, finely zested" },
    ],
    steps: [
      "Whisk the flour, baking powder, and salt. Fold in the yogurt until a shaggy dough forms, then knead briefly until smooth.",
      "Divide into six balls and roll each into a thin oval on a lightly floured surface.",
      "Cook in a hot dry skillet for about 90 seconds per side, until blistered and cooked through.",
      "Mix the olive oil, za’atar, and lemon zest. Brush over the warm breads and serve immediately.",
    ],
    productSlugs: ["zaatar", "pink-salt"],
  },
  {
    id: 3,
    slug: "cardamom-cinnamon-pear-oats",
    title: "Cardamom-Cinnamon Pear Oats",
    excerpt:
      "Creamy morning oats layered with browned pears, true cinnamon, and freshly cracked cardamom.",
    image: "/images/generated/recipe-pear-oats.png",
    prepTime: 8,
    cookTime: 18,
    totalTime: 26,
    servings: 2,
    difficulty: "Easy",
    cuisine: "Everyday",
    tags: ["breakfast", "vegetarian", "one-pot"],
    ingredients: [
      { amount: "1 cup", item: "rolled oats" },
      { amount: "2 cups", item: "milk or unsweetened oat milk" },
      { amount: "4 pods", item: "Nilgiri Green Cardamom, seeds crushed", productSlug: "green-cardamom" },
      { amount: "1 tsp", item: "Sun-Warmed Ceylon Cinnamon", productSlug: "ceylon-cinnamon" },
      { amount: "2", item: "ripe pears, sliced" },
      { amount: "1 tbsp", item: "butter or olive oil" },
      { amount: "2 tsp", item: "maple syrup, plus more to serve" },
    ],
    steps: [
      "Combine oats, milk, cardamom, and half the cinnamon in a saucepan. Simmer gently for 8–10 minutes, stirring often.",
      "Meanwhile, brown the pears in butter in a skillet. Add maple syrup and the remaining cinnamon, then cook until glossy.",
      "Divide the oats between bowls, spoon over the warm pears, and finish with maple syrup and a pinch of crushed cardamom.",
    ],
    productSlugs: ["green-cardamom", "ceylon-cinnamon"],
  },
  {
    id: 4,
    slug: "saffron-citrus-rice",
    title: "Saffron Citrus Celebration Rice",
    excerpt:
      "Long-grain rice jeweled with saffron, orange, pistachios, and aromatic cardamom.",
    image: "/images/generated/recipe-saffron-rice.png",
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    servings: 6,
    difficulty: "Moderate",
    cuisine: "Persian-inspired",
    tags: ["rice", "celebration", "gluten-free"],
    ingredients: [
      { amount: "1 1/2 cups", item: "basmati rice, rinsed" },
      { amount: "1/2 tsp", item: "Dawn Harvest Saffron", productSlug: "saffron" },
      { amount: "5 pods", item: "Nilgiri Green Cardamom, lightly crushed", productSlug: "green-cardamom" },
      { amount: "2 tbsp", item: "unsalted butter or olive oil" },
      { amount: "1", item: "orange" },
      { amount: "1/3 cup", item: "toasted pistachios" },
      { amount: "1 tsp", item: "Rose Quartz Pink Salt", productSlug: "pink-salt" },
    ],
    steps: [
      "Crush the saffron with a pinch of salt, cover with 3 tablespoons warm water, and steep for 10 minutes.",
      "Cook the rice with cardamom and salt until just tender. Rest, covered, for 10 minutes before fluffing.",
      "Fold in butter, saffron water, finely grated orange zest, and two tablespoons orange juice.",
      "Transfer to a platter and scatter with pistachios and a few threads of saffron.",
    ],
    productSlugs: ["saffron", "green-cardamom", "pink-salt"],
  },
  {
    id: 5,
    slug: "berbere-roasted-cauliflower",
    title: "Berbere Roasted Cauliflower with Tahini",
    excerpt:
      "Deeply browned cauliflower with aromatic chile heat, cool tahini, and flaky salt.",
    image: "/images/generated/recipe-berbere-cauliflower.png",
    prepTime: 12,
    cookTime: 32,
    totalTime: 44,
    servings: 4,
    difficulty: "Easy",
    cuisine: "Ethiopian-inspired",
    tags: ["vegan", "roasting", "spicy"],
    ingredients: [
      { amount: "1 large", item: "cauliflower, cut into florets" },
      { amount: "2 tbsp", item: "olive oil" },
      { amount: "1 1/2 tbsp", item: "Red Clay Berbere", productSlug: "ember-berbere" },
      { amount: "3/4 tsp", item: "Rose Quartz Pink Salt", productSlug: "pink-salt" },
      { amount: "1/3 cup", item: "tahini" },
      { amount: "1", item: "lemon" },
      { amount: "1/2 tsp", item: "Snowflake Sea Salt", productSlug: "flaky-sea-salt" },
    ],
    steps: [
      "Heat the oven to 450°F. Toss cauliflower with olive oil, berbere, and pink salt.",
      "Roast cut-side down for 28–32 minutes, turning once, until deeply browned at the edges.",
      "Whisk tahini with lemon juice and enough cold water to make a spoonable sauce.",
      "Spread tahini on a plate, add the cauliflower, and finish with flaky salt and lemon zest.",
    ],
    productSlugs: ["ember-berbere", "pink-salt", "flaky-sea-salt"],
  },
  {
    id: 6,
    slug: "sumac-herb-lentil-salad",
    title: "Ruby Sumac Lentil & Herb Salad",
    excerpt:
      "A picnic-ready lentil salad sharpened with sumac, oregano, cucumber, and herbs.",
    image: "/images/generated/recipe-sumac-lentils.png",
    prepTime: 18,
    cookTime: 24,
    totalTime: 42,
    servings: 4,
    difficulty: "Easy",
    cuisine: "Eastern Mediterranean-inspired",
    tags: ["vegan", "make-ahead", "lunch"],
    ingredients: [
      { amount: "1 cup", item: "green lentils" },
      { amount: "1 tbsp", item: "Ruby Sumac", productSlug: "tart-sumac" },
      { amount: "1 tsp", item: "Mountain Greek Oregano", productSlug: "greek-oregano" },
      { amount: "1", item: "small cucumber, diced" },
      { amount: "1 cup", item: "chopped parsley and mint" },
      { amount: "3 tbsp", item: "extra-virgin olive oil" },
      { amount: "1", item: "lemon" },
      { amount: "3/4 tsp", item: "Snowflake Sea Salt", productSlug: "flaky-sea-salt" },
    ],
    steps: [
      "Simmer lentils in salted water until tender but intact, about 20–24 minutes. Drain well.",
      "While warm, toss the lentils with sumac, oregano, olive oil, lemon zest, and lemon juice.",
      "Cool for 10 minutes, then fold in cucumber and fresh herbs.",
      "Taste for salt and acidity, then serve at room temperature or chill for up to two days.",
    ],
    productSlugs: ["tart-sumac", "greek-oregano", "flaky-sea-salt"],
  },
];

export const getRecipeBySlug = (slug) =>
  recipes.find((recipe) => recipe.slug === slug);

export { recipes };
export default recipes;
